'use client';

import { useState } from 'react';

// Lightweight YouTube facade: renders the poster thumbnail + a play button and
// only injects the (heavy) YouTube iframe on click. Keeps ~hundreds of KB of
// player JS and third-party cookies off the initial load — the recommended way
// to embed YouTube on a landing page.

export default function LiteYouTube({ id, title }: { id: string; title: string }) {
  const [play, setPlay] = useState(false);

  return (
    <div className="lyt">
      {play ? (
        <iframe
          className="lyt-frame"
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          className="lyt-btn"
          onClick={() => setPlay(true)}
          aria-label={`Play video: ${title}`}
        >
          <img
            className="lyt-thumb"
            src={`https://i.ytimg.com/vi/${id}/maxresdefault.jpg`}
            alt=""
            loading="lazy"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src =
                `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
            }}
          />
          <span className="lyt-play" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
        </button>
      )}
    </div>
  );
}
